import { VerseReference } from '../types';

export const parseVerseReference = (input: string): VerseReference | null => {
  const pattern = /^([1-3]?\s?[A-Za-z]+)\s+(\d+):(\d+)(?:-(\d+))?$/;
  const match = input.trim().match(pattern);
  
  if (!match) return null;
  
  const book = match[1].trim();
  const chapter = parseInt(match[2], 10);
  const verse = parseInt(match[3], 10);
  const endVerse = match[4] ? parseInt(match[4], 10) : null;
  
  const display = endVerse 
    ? `${book} ${chapter}:${verse}-${endVerse}`
    : `${book} ${chapter}:${verse}`;
  
  const id = endVerse
    ? `${book}-${chapter}-${verse}-${endVerse}`.toLowerCase().replace(/\s+/g, '-')
    : `${book}-${chapter}-${verse}`.toLowerCase().replace(/\s+/g, '-');
  
  return {
    id,
    book,
    chapter,
    verse,
    ...(endVerse ? { endVerse } : {}),
    display
  };
};

export const generateVerseId = (): string => {
  return `note-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;
};
